import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import { i18n } from '@/i18n'
import VueGtag from 'vue-gtag'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

axios.defaults.baseURL = '/api'
axios.interceptors.response.use(
  response => response,
  error => {
    if (403 === error.response.status && store.getters.isAuthenticated) {
      store.dispatch('AUTH_LOGOUT')
      return
    }
    return Promise.reject(error)
  }
)
axios.interceptors.request.use(
  config => {
    if (store.getters.isAuthenticated) {
      config.headers.Authorization = 'Bearer ' + store.getters.authToken
    }
    return config
  },
  err => Promise.reject(err)
)

// const log = require('bows')('main.js', '[FE]')

// ICONS
Vue.component('font-awesome-icon', FontAwesomeIcon)
import {
  faTrash as fasTrash,
  faHeart as fasHeart,
  faGlobe as fasGlobe,
  faCaretDown as fasCaretDown,
  faCheck as fasCheck,
  faComments as fasComments,
  faChevronCircleRight as fasChevronCircleRight,
  faLink as fasLink,
  faFile as fasFile,
  faMapMarkedAlt as fasMapMarkedAlt,
  faQuestion as fasQuestion,
  faTimes as fasTimes,
  faSignOutAlt as fasSignOutAlt,
  faSignInAlt as fasSignInAlt,
  faUsers as fasUsers,
  faKey as fasKey,
  faPaperPlane as fasPaperPlane
} from '@fortawesome/free-solid-svg-icons'

import {
  faHeart as farHeart,
  faTrashAlt as farTrashAlt,
  faImage as farImage
} from '@fortawesome/free-regular-svg-icons'

import { faYoutube as fabYoutube, faSpotify as fabSpotify } from '@fortawesome/free-brands-svg-icons'

library.add(farTrashAlt)
library.add(fasTimes)
library.add(farHeart)
library.add(fasHeart)
library.add(fasTrash)
library.add(farImage)
library.add(fasCaretDown)
library.add(fasGlobe)
library.add(fasComments)
library.add(fasChevronCircleRight)
library.add(fasLink)
library.add(fasFile)
library.add(fasMapMarkedAlt)
library.add(fasQuestion)
library.add(fasCheck)
library.add(fasSignOutAlt)
library.add(fasSignInAlt)
library.add(fasUsers)
library.add(fasKey)
library.add(fasPaperPlane)
library.add(fabYoutube)
library.add(fabSpotify)

Vue.config.productionTip = false

Vue.directive('child', {
  bind(el, binding) {
    el.appendChild(binding.value)
  }
})

Vue.use(VueGtag, {
  bootstrap: false
})

new Vue({
  router,
  store,
  i18n,
  created() {},
  render: h => h(App)
}).$mount('#app')
